<template>
  <div class="d-inline">
    <p class="pa-0 ma-0">{{ material.coleccion }}</p>
    <p class="pa-0 ma-0">{{ material.formato }}</p>
    <p class="pa-0 ma-0">{{ tipoDeMaterial(material) }}</p>
  </div>
</template>

<script>
export default {
  name: "DescripcionMatPersCmp",
  props: {
    material: {required: true, type: Object}
  },
  methods: {
    tipoDeMaterial(material) {
      let tipos = [];
      material.ceramicos.forEach((cer) => {
        tipos.push(cer.nombre);
      });
      material.noCeramicos.forEach((noCer) => {
        tipos.push(noCer.nombre);
      });

      return tipos.join(", ");
    }
  }
}
</script>

<style scoped>

</style>